import { render, staticRenderFns } from "./RouterView.vue?vue&type=template&id=63251cbe&"
var script = {}


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('63251cbe')) {
      api.createRecord('63251cbe', component.options)
    } else {
      api.reload('63251cbe', component.options)
    }
    module.hot.accept("./RouterView.vue?vue&type=template&id=63251cbe&", function () {
      api.rerender('63251cbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/RouterView.vue"
export default component.exports